// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__Vd1sL","messages":"Chat_messages__3uWky","dateDivider":"Chat_dateDivider__18jIF"};